import * as React from 'react'

import CostAnalysisResults from './../components/admin/costAnalysisResults'

class CostAnalysis extends React.Component {

  render() {
    return (
      <div className='analysis-container'>
        <CostAnalysisResults />
      </div>
    )
  }
}

export default CostAnalysis



// WEBPACK FOOTER //
// ./src/pages/costAnalysis.js